<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="700px" transition="dialog-bottom-transition">
      <v-card>
        <v-form @submit.prevent v-on:submit.prevent="save">
          <v-card-title>
            <span class="headline">Editar observaciones</span>
          </v-card-title>

          <v-card-text>
            <v-row v-if="asn != null">
              <v-col cols="12" md="4">
                <v-text-field label="Numero" :model-value="asn.id" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Cliente" :model-value="asn.client_name != null ? asn.client_name : '-'" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Estado" :model-value="asn.status != null ? service.getStatusName(asn.status) : '-'" disabled></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea label="Observaciones" v-model="observaciones" rows="4"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" variant="text" @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" variant="text" type="submit" :loading="loading">Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { asnService } from "@/libs/ws/asnService";

export default {
  components: {},
  mixins: [],
  props: {
    dialog: Boolean,
    asn: { Type: Object, default: null },
  },
  data() {
    return {
      service: asnService,
      observaciones: "",
      loading: false,
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.observaciones = this.asn != null && this.asn.observaciones != null ? this.asn.observaciones : "";
      }
    },
  },
  mounted() {},
  methods: {
    save() {
      if (this.loading) return;

      this.loading = true;
      asnService
        .updateObservaciones({ asn_id: this.asn.id, observaciones: this.observaciones })
        .then((response) => {
          if (response.status === true) {
            this.toast.success(response.msg);
            this.$emit("updateDialog", false);
            this.$emit("loadList", asnService);
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((error) => {
          this.toast.error("Error al actualizar las observaciones");
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
